<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Questions fréquemment posées" />
            <FaqComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FaqComp from '../Faq/FaqComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'FaqPage',
    components: {
        NavBar,
        PageTitle,
        FaqComp,
        FooterComp,
    }
}
</script>